import React, {useState, useEffect} from 'react';
import Timer from 'react-compound-timer';
import moment from 'moment';
import {useTranslation} from 'react-i18next';

export const UnifiedPromotionTimer = ({
  promotionDateTo,
  showLabel = true,
  variant = 'full',
  customStyles = {}
}) => {
  const {t} = useTranslation();
  const toDay = moment().valueOf();
  const endTime = moment(promotionDateTo).valueOf();
  const initialTime = endTime - toDay;
  const [timerValues, setTimerValues] = useState({days: 0, hours: 0, minutes: 0, seconds: 0});

  if (initialTime <= 0) {
    return null;
  }

  const getPluralForm = (value, key) => {
    const absValue = Math.abs(Math.floor(value));
    const lastDigit = absValue % 10;
    const lastTwoDigits = absValue % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
      return t(`common:${key}_many`, {count: value});
    }
    if (lastDigit === 1) {
      return t(`common:${key}`, {count: value});
    }
    if (lastDigit >= 2 && lastDigit <= 4) {
      return t(`common:${key}_plural`, {count: value});
    }
    return t(`common:${key}_many`, {count: value});
  };

  const getFirstLetter = (word) => word.charAt(0);

  const calculateDisplayDays = () => {
    const totalHours = Math.floor(initialTime / (1000 * 60 * 60));
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    
    if (days === 0) return 1;
    if (hours > 0) return days + 1;
    return days;
  };

  return (
    <>
      {variant === 'full' && (
        <div style={customStyles.wrapper}>
          {showLabel && (
            <div className="timer-title" style={customStyles.label}>
              {t('common:It_remained_until')}:
            </div>
          )}
          <Timer
            initialTime={initialTime}
            direction="backward">
            <div className="timers" style={customStyles.container}>
              <div className="timer" style={customStyles.timer}>
                <Timer.Days /> <span>{t('common:days')}</span>
              </div>
              <div className="timer" style={customStyles.timer}>
                <Timer.Hours /> <span>{t('common:hours')}</span>
              </div>
              <div className="timer" style={customStyles.timer}>
                <Timer.Minutes /> <span>{t('common:minutes')}</span>
              </div>
              <div className="timer" style={customStyles.timer}>
                <Timer.Seconds /> <span>{t('common:seconds')}</span>
              </div>
            </div>
          </Timer>
        </div>
      )}

      {variant === 'compact' && (
        <div style={customStyles.wrapper}>
          {showLabel && (
            <div className="timer-title" style={customStyles.label}>
              {t('common:It_remained_until')}:
            </div>
          )}
          <Timer
            initialTime={initialTime}
            direction="backward">
            <div className="timers" style={customStyles.container}>
              <div className="timer" style={customStyles.timer}>
                <Timer.Days /> <span>{getFirstLetter(t('common:days'))}.</span>
              </div>
              <div className="timer" style={customStyles.timer}>
                <Timer.Hours /> <span>{getFirstLetter(t('common:hours'))}.</span>
              </div>
              <div className="timer" style={customStyles.timer}>
                <Timer.Minutes /> <span>{getFirstLetter(t('common:minutes'))}.</span>
              </div>
              <div className="timer" style={customStyles.timer}>
                <Timer.Seconds /> <span>{getFirstLetter(t('common:seconds'))}.</span>
              </div>
            </div>
          </Timer>
        </div>
      )}

      {variant === 'days-only' && (
        <div className="promotion__footer" style={customStyles.wrapper}>
          {showLabel && (
            <span>
              {t('common:It_remained_until')}:{' '}
            </span>
          )}
          <span style={customStyles.inline}>
            {calculateDisplayDays()} {getPluralForm(calculateDisplayDays(), 'day')}
          </span>
        </div>
      )}

      {variant === 'product-footer' && (
        <div className="promotion__footer" style={customStyles.wrapper}>
          <div style={customStyles.label}>
            {t('common:It_remained_until')}:{' '}
            <span style={customStyles.inline}>
              {calculateDisplayDays()} {getPluralForm(calculateDisplayDays(), 'day')}
            </span>
          </div>
        </div>
      )}

      {variant === 'inline-list' && (
        <ul className="product__discount-list" style={customStyles.wrapper}>
          <Timer
            initialTime={initialTime}
            direction="backward">
            <li className="product__discount-item">
              <Timer.Days /> <span>{t('common:days')}</span>
            </li>
            <li className="product__discount-item">
              <Timer.Hours /> <span>{t('common:hours')}</span>
            </li>
            <li className="product__discount-item">
              <Timer.Minutes /> <span>{t('common:minutes')}</span>
            </li>
            <li className="product__discount-item">
              <Timer.Seconds /> <span>{t('common:seconds')}</span>
            </li>
          </Timer>
        </ul>
      )}
    </>
  );
};

export default UnifiedPromotionTimer;